import { render, staticRenderFns } from "./detailConcepts.vue?vue&type=template&id=4acf9d34&scoped=true&"
import script from "./detailConcepts.vue?vue&type=script&lang=js&"
export * from "./detailConcepts.vue?vue&type=script&lang=js&"
import style0 from "./detailConcepts.vue?vue&type=style&index=0&id=4acf9d34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acf9d34",
  null
  
)

export default component.exports